import {Pipe, PipeTransform} from '@angular/core';

@Pipe({ name: 'appPojo' })
export class PojoPipe implements PipeTransform {
  transform(value: any): any {
    if (value === null || value === undefined) {
      return value;
    }
    if (typeof value !== 'object') {
      return value;
    }

    if (Array.isArray(value)) {
      return value.map(item => {
        if (typeof item === 'object' && item !== null) {
          return Object.assign({}, item);
        }
        return item;
      });
    }

    return Object.assign({}, value);
  }
}
